import React from "react";

export const Logo = ({ size = 36, showText = true, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <img
      src="https://customer-assets.emergentagent.com/job_7ab30a26-e695-4389-ab48-4c6affa84a8d/artifacts/gobkg9sm_Gyandhara_logo_1000_1000.png"
      alt="Gyan Dhara"
      style={{ width: size, height: size }}
      className="rounded-lg"
      data-testid="gyan-dhara-logo"
    />
    {showText && (
      <span className="text-xl font-bold tracking-tight text-white">Gyan Dhara</span>
    )}
  </div>
);

export const LogoDark = ({ size = 40 }) => (
  <div className="flex items-center gap-3">
    <img
      src="https://customer-assets.emergentagent.com/job_7ab30a26-e695-4389-ab48-4c6affa84a8d/artifacts/gobkg9sm_Gyandhara_logo_1000_1000.png"
      alt="Gyan Dhara"
      style={{ width: size, height: size }}
      className="rounded-xl"
    />
    <span className="text-2xl font-bold tracking-tight text-slate-900">Gyan Dhara</span>
  </div>
);
